export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  publishDate: string;
  readTime: string;
  imageQuery: string;
  tags: string[];
  featured: boolean;
}

export const articles: Article[] = [
  {
    id: '1',
    slug: 'tianmei-lolita-rumen-zhinan',
    title: '甜美洛丽塔入门指南：从零开始打造你的梦幻衣橱',
    excerpt: '甜美洛丽塔作为最受欢迎的洛丽塔风格之一，以其粉嫩色调、梦幻蕾丝和甜美蝴蝶结俘获了无数少女心。本文将带你从基础单品开始，逐步构建属于自己的甜美洛丽塔衣橱。',
    content: `<p>甜美洛丽塔（Sweet Lolita）是洛丽塔时尚中最广为人知的风格流派。它以粉嫩柔和的色调、繁复精致的蕾丝装饰、可爱的蝴蝶结以及蓬松的裙摆为标志性特征，旨在打造宛如童话中走出的洋娃娃般梦幻甜美的形象。</p>
<h2>甜美洛丽塔的核心元素</h2>
<p>要打造一套完整的甜美洛丽塔造型，以下几个核心元素缺一不可：首先是<strong>跳线裙（JSK）或有袖连衣裙（OP）</strong>，这是整套造型的核心单品。甜美洛丽塔的裙子通常采用粉色、白色、浅蓝色或薰衣草色等柔美色调，裙身布满蕾丝、荷叶边和蝴蝶结装饰。</p>
<p>其次是<strong>衬衫（Blouse）</strong>，搭配JSK穿着。甜美洛丽塔的衬衫通常采用彼得潘领或圆领设计，袖口多为蓬松的泡泡袖或蕾丝喇叭袖，整体风格甜美可人。</p>
<p>第三是<strong>裙撑（Petticoat）</strong>，它是塑造洛丽塔标志性A字廓形或钟形廓形的关键。选择合适蓬松度的裙撑，能让裙子呈现出完美的弧度与立体感。</p>
<p>最后是<strong>头饰（Headpiece）</strong>，甜美洛丽塔最常见的头饰包括蝴蝶结发夹（KC）、波奈特（Bonnet）以及各式花环头饰，它们能为整体造型增添画龙点睛的效果。</p>
<h2>白丝搭配的艺术</h2>
<p>在甜美洛丽塔的造型中，白色丝袜或白色及膝袜是最经典的腿部搭配选择。<strong>白丝</strong>不仅能衬托出洛丽塔裙装的甜美气质，还能在视觉上拉长腿部线条，营造出清纯可爱的整体形象。</p>
<p>选择白丝时需要注意材质和厚度。棉质白丝更加透气舒适，适合春夏季节；天鹅绒质地的白丝则更显高级质感，适合秋冬穿搭。图案方面，纯白素色最为百搭，而带有精致蕾丝边或小蝴蝶结装饰的白丝则能为造型增添更多甜美细节。</p>
<h2>新手入门推荐清单</h2>
<p>如果你是刚刚接触洛丽塔时尚的新手，建议从以下单品开始逐步构建衣橱：一条基础款粉白配色JSK、一件百搭白色蕾丝衬衫、一条A字型裙撑、一双纯白及膝袜、一双圆头玛丽珍鞋，以及一个基础款蝴蝶结发夹。这些单品组合在一起，就能完成一套入门级的甜美洛丽塔造型。</p>`,
    category: 'tianmei-lolita',
    author: '小雪',
    publishDate: '2026-07-28',
    readTime: '8分钟',
    imageQuery: 'Sweet%20Lolita%20fashion%20beginner%20guide%20with%20pink%20dress%20white%20lace%20stockings%20and%20bows%2C%20cute%20wardrobe%20display%20on%20vanity%20table%2C%20soft%20pastel%20pink%20background%2C%20dreamy%20feminine%20editorial%20photography%20with%20gentle%20natural%20light',
    tags: ['甜美洛丽塔', '入门指南', '穿搭技巧', '白丝搭配'],
    featured: true,
  },
  {
    id: '2',
    slug: 'gudian-lolita-pinpai-pan-dian',
    title: '古典洛丽塔品牌大盘点：从日系经典到国牌新秀',
    excerpt: '古典洛丽塔以其优雅端庄的气质深受成熟女性和复古爱好者的青睐。本文将为你盘点国内外最具代表性的古典洛丽塔品牌，从设计风格到价格定位，助你找到最适合自己的那一款。',
    content: `<p>古典洛丽塔（Classic Lolita）是洛丽塔时尚中最具成熟韵味的风格流派。它汲取了维多利亚时代和洛可可时期的服装元素，以沉稳典雅的色调、精致考究的面料、端庄大方的剪裁为特色，展现的是一种不张扬却极具质感的贵族气质。</p>
<h2>日系经典品牌</h2>
<p>在日本洛丽塔时尚界，<strong>Baby, the Stars Shine Bright</strong> 和 <strong>Alice and the Pirates</strong> 是古典洛丽塔风格的代表性品牌。Baby的古典系列以优雅的印花和精致的蕾丝著称，色调多采用酒红、深蓝、墨绿等沉稳色系；而Alice品牌则融入了更多复古航海元素，风格更为独特鲜明。</p>
<p><strong>Victorian Maiden</strong> 则是另一个专注于古典洛丽塔的品牌，其设计更加贴近维多利亚时代的原始风格，采用大量的荷叶边、高领设计和长袖款式，非常适合追求纯粹复古风格的爱好者。</p>
<h2>国牌新秀崛起</h2>
<p>近年来，中国本土洛丽塔品牌发展迅猛，涌现出了一批优秀的古典洛丽塔品牌。<strong>古典玩偶</strong>以精致的手工刺绣和考究的面料选择著称，设计灵感多来源于中国古典文学和欧洲宫廷文化，深受资深洛丽塔爱好者的喜爱。</p>
<p><strong>仲夏物语</strong>则以其清新雅致的设计风格脱颖而出，在古典洛丽塔的基础上融入了更多的日常可穿性考量，让古典洛丽塔不再是特殊场合的专属，而是可以融入日常生活。</p>
<h2>如何选择适合自己的古典洛丽塔品牌</h2>
<p>选择古典洛丽塔品牌时，建议从以下几个方面考量：首先是<strong>设计风格</strong>，不同品牌在古典洛丽塔这个大框架下有着各自独特的美学取向；其次是<strong>尺码适配</strong>，亚洲品牌通常更适合娇小身材，而欧美品牌则尺码更丰富；最后是<strong>预算范围</strong>，日系品牌通常价格较高，国牌则在性价比方面更有优势。</p>`,
    category: 'pinpai-tuijian',
    author: '花音',
    publishDate: '2026-07-25',
    readTime: '10分钟',
    imageQuery: 'Classic%20Lolita%20brand%20collection%20display%20with%20elegant%20Victorian%20style%20dresses%20in%20deep%20burgundy%20and%20navy%2C%20luxurious%20fabric%20close-up%2C%20vintage%20boutique%20interior%20with%20warm%20lighting%2C%20refined%20fashion%20photography',
    tags: ['古典洛丽塔', '品牌推荐', '日系品牌', '国牌'],
    featured: true,
  },
  {
    id: '3',
    slug: 'gete-lolita-heian-meixue',
    title: '哥特洛丽塔的暗黑美学：在黑暗中绽放的优雅之花',
    excerpt: '哥特洛丽塔融合了哥特文化的暗黑元素与洛丽塔的甜美轮廓，创造出一种独特而迷人的风格。黑色蕾丝、十字架、蔷薇——这些元素如何组合出令人惊艳的暗黑优雅？',
    content: `<p>哥特洛丽塔（Gothic Lolita）是洛丽塔时尚中最具戏剧性和视觉冲击力的风格流派。它将哥特文化的暗黑神秘与洛丽塔服装的甜美廓形巧妙融合，创造出一种同时兼具优雅与叛逆气质的独特美学。</p>
<h2>哥特洛丽塔的标志性元素</h2>
<p>黑色是哥特洛丽塔的绝对主色调，但这并不意味着单调。<strong>不同材质的黑色</strong>——哑光棉布、光泽缎面、透明蕾丝、柔软天鹅绒——层层叠加，营造出丰富的视觉层次感。</p>
<p>在图案和装饰方面，哥特洛丽塔常用<strong>十字架、蝙蝠、蔷薇、蜘蛛网、铁窗花</strong>等元素。这些图案或以印花形式出现在裙身，或以金属饰品、刺绣贴花的形式点缀在领口、袖口和裙摆处。</p>
<p>头饰方面，哥特洛丽塔偏爱黑色蕾丝发带、迷你礼帽、黑色玫瑰发饰以及带有面纱的小礼帽（Mini Hat），这些头饰能为造型增添神秘高贵的气质。</p>
<h2>白丝在哥特洛丽塔中的运用</h2>
<p>虽然哥特洛丽塔以黑色为主调，但<strong>白色丝袜</strong>却常常作为点睛之笔出现在哥特洛丽塔造型中。黑白对比形成的强烈视觉冲击，能让整套造型更加鲜明有力。带有哥特风格提花图案的白丝——如蔷薇藤蔓、十字架纹样——更是将甜美与暗黑完美融合的绝佳选择。</p>
<h2>打造哥特洛丽塔日常造型</h2>
<p>哥特洛丽塔不一定是夸张的舞台造型，它同样可以融入日常穿着。选择一条基础款黑色JSK搭配简约的白色蕾丝衬衫，再配上一双带有暗纹的白丝和黑色玛丽珍鞋，就能完成一套既保留哥特洛丽塔核心风格又适合日常出街的造型。</p>`,
    category: 'gete-lolita',
    author: '夜樱',
    publishDate: '2026-07-22',
    readTime: '7分钟',
    imageQuery: 'Gothic%20Lolita%20fashion%20with%20black%20lace%20dress%20and%20white%20stockings%2C%20dark%20elegant%20rose%20and%20cross%20motifs%2C%20mysterious%20moonlit%20atmosphere%2C%20dramatic%20cathedral%20window%20background%2C%20dark%20romantic%20editorial%20photography',
    tags: ['哥特洛丽塔', '暗黑美学', '黑白搭配', '风格解析'],
    featured: true,
  },
  {
    id: '4',
    slug: 'zhonghuafeng-lolita-dongfang-shenyun',
    title: '中华风洛丽塔：当东方古典遇见西方浪漫',
    excerpt: '中华风洛丽塔是近年来最受关注的新兴洛丽塔流派，它将中国传统元素与洛丽塔裙装完美融合。盘扣、刺绣、云肩——这些东方美学元素如何在洛丽塔上焕发新生？',
    content: `<p>中华风洛丽塔（Wa Lolita / Qi Lolita）是洛丽塔时尚中最具文化融合特色的风格流派。它将中国传统服饰元素——如旗袍的立领盘扣、汉服的宽袖云肩、精致的刺绣工艺——巧妙地融入到洛丽塔的蓬裙廓形之中，创造出一种兼具东方韵味与西方浪漫的独特美学。</p>
<h2>中华风洛丽塔的核心设计元素</h2>
<p><strong>中式领口与盘扣</strong>是中华风洛丽塔最具辨识度的设计特征。改良的立领设计搭配精致的手工盘扣，既保留了东方服饰的端庄气质，又与洛丽塔的甜美廓形相得益彰。</p>
<p><strong>刺绣工艺</strong>在中华风洛丽塔中扮演着至关重要的角色。仙鹤、牡丹、梅花、祥云、凤凰等传统纹样以精美的刺绣形式呈现在裙身之上，每一针每一线都诉说着千年的东方故事。</p>
<p><strong>云肩与披帛</strong>的设计则为中华风洛丽塔增添了飘逸灵动的气质。轻盈的纱质云肩或刺绣披帛搭配蓬松的洛丽塔裙摆，营造出一种仙气飘飘的视觉效果，让人联想到古代仕女图中的曼妙身姿。</p>
<h2>中华风洛丽塔的色彩美学</h2>
<p>中华风洛丽塔在色彩运用上大量借鉴了<strong>中国传统配色</strong>——朱砂红、月白、秋香绿、藕荷紫、鸦青——这些富有诗意的中国传统色彩为洛丽塔裙装注入了独特的东方美学基因。</p>`,
    category: 'zhonghuafeng-lolita',
    author: '素月',
    publishDate: '2026-07-18',
    readTime: '9分钟',
    imageQuery: 'Chinese%20style%20Lolita%20fashion%20with%20traditional%20silk%20embroidery%20and%20cloud%20shoulder%20design%2C%20elegant%20Eastern%20and%20Western%20fusion%20dress%2C%20warm%20lantern%20light%20background%2C%20soft%20beige%20and%20vermilion%20tones%2C%20cultural%20fusion%20editorial%20photography',
    tags: ['中华风洛丽塔', '东方美学', '文化融合', '刺绣工艺'],
    featured: false,
  },
  {
    id: '5',
    slug: 'chuntian-lolita-chuanda-fangan',
    title: '春日洛丽塔穿搭方案：用柔美色彩迎接花开季节',
    excerpt: '春天是洛丽塔爱好者最期待的季节。樱花粉、薄荷绿、鹅蛋黄——这些春日色彩如何在洛丽塔造型中完美呈现？本文为你准备了五套完整的春日洛丽塔穿搭方案。',
    content: `<p>春天是洛丽塔时尚最美好的季节。温暖的阳光、盛开的鲜花、轻柔的微风——这一切都与洛丽塔的浪漫气质完美契合。春季洛丽塔穿搭的关键词是<strong>轻盈、柔美、色彩</strong>，让我们一起来看看这个春天最值得尝试的洛丽塔造型方案。</p>
<h2>方案一：樱花粉主题造型</h2>
<p>以浅粉色JSK为核心单品，裙身点缀精致的樱花印花，搭配纯白色蕾丝衬衫和粉色蝴蝶结发夹。脚上穿一双白色圆头玛丽珍鞋，搭配<strong>纯白蕾丝边及膝袜</strong>，整体色调柔和统一，宛如春日里盛开的樱花一般甜美可人。</p>
<h2>方案二：薄荷绿清新造型</h2>
<p>薄荷绿色OP连衣裙搭配白色蕾丝手套和珍珠发箍，清新自然的配色让人联想到初春的新芽。选择带有白色蕾丝花边装饰的薄荷绿裙装，搭配素色白丝和白色低跟鞋，整体造型清新脱俗。</p>
<h2>方案三：鹅蛋黄田园造型</h2>
<p>鹅黄色JSK搭配米白色棉质蕾丝衬衫，头戴草编波奈特帽饰，手挽竹编小包，打造田园诗般的春日洛丽塔造型。脚上选择带有雏菊刺绣图案的白丝，为整体造型增添一抹田园野趣。</p>`,
    category: 'chuanda-zhinan',
    author: '小雪',
    publishDate: '2026-07-15',
    readTime: '6分钟',
    imageQuery: 'Spring%20Lolita%20fashion%20outfit%20with%20cherry%20blossom%20pink%20dress%20and%20white%20lace%20stockings%2C%20pastel%20color%20coordination%2C%20outdoor%20garden%20cherry%20blossom%20background%2C%20soft%20spring%20sunlight%2C%20romantic%20feminine%20editorial%20photography',
    tags: ['春季穿搭', '色彩搭配', '穿搭方案', '白丝造型'],
    featured: true,
  },
  {
    id: '6',
    slug: 'luolita-chahuizhinan',
    title: '洛丽塔茶会完全指南：从着装礼仪到社交技巧',
    excerpt: '洛丽塔茶会不仅是展示精美裙装的场合，更是洛丽塔爱好者交流互动的重要社交活动。如何准备一场完美的茶会造型？茶会上又有哪些需要注意的礼仪细节？',
    content: `<p>洛丽塔茶会（Lolita Tea Party）是洛丽塔文化中最具代表性的社交活动形式。它起源于欧洲下午茶文化，与洛丽塔服装的古典优雅气质完美契合，逐渐发展为洛丽塔爱好者展示自我、交流心得的专属社交场合。</p>
<h2>茶会着装规范</h2>
<p>参加洛丽塔茶会，着装是重中之重。一般来说，茶会的着装要求较为<strong>正式</strong>，建议选择设计精美、面料考究的洛丽塔裙装。古典洛丽塔和甜美洛丽塔都是茶会的经典选择，而过于夸张的哥特洛丽塔造型则需根据茶会主题酌情考量。</p>
<p>配饰方面，<strong>头饰与手套</strong>是茶会造型中不可或缺的元素。精致的波奈特或优雅的发带能让整体造型更加完整，而蕾丝手套则能为举手投足间增添一份优雅气质。脚上建议搭配精致的白丝和优雅的低跟鞋或玛丽珍鞋。</p>
<h2>茶会社交礼仪</h2>
<p>洛丽塔茶会不仅仅是服装展示，更是社交场合。以下几点礼仪值得注意：入场时主动向主办方致意问候；品尝茶点时注意餐桌礼仪，小口品尝，保持优雅；与他人交流时保持友善热情的态庺，多给予他人真诚的赞美；如需拍照，务必先征得对方同意。</p>`,
    category: 'huodong-zixun',
    author: '花音',
    publishDate: '2026-07-12',
    readTime: '8分钟',
    imageQuery: 'Elegant%20Lolita%20tea%20party%20with%20beautifully%20set%20table%20with%20vintage%20teacups%20and%20pastries%2C%20participants%20in%20formal%20Lolita%20dresses%2C%20warm%20afternoon%20venue%20with%20floral%20decoration%2C%20sophisticated%20social%20gathering%20photography',
    tags: ['茶会指南', '社交礼仪', '活动攻略', '着装规范'],
    featured: false,
  },
  {
    id: '7',
    slug: 'baise-siwa-dapei-yishu',
    title: '白丝搭配艺术：洛丽塔造型中不可忽视的腿部美学',
    excerpt: '在洛丽塔造型中，白色丝袜不仅是基础单品，更是决定整体风格的关键配饰。从材质选择到图案搭配，掌握白丝的搭配艺术，让你的洛丽塔造型更加完美。',
    content: `<p>在洛丽塔时尚中，<strong>白丝</strong>（白色丝袜/白色及膝袜）是最经典且不可或缺的腿部搭配单品。它不仅承载着实用的穿搭功能，更在整体造型中扮演着至关重要的美学角色。一条选择得当的白丝，能让洛丽塔造型锦上添花；而一条不合适的白丝，则可能破坏整体造型的和谐感。</p>
<h2>白丝的材质选择</h2>
<p>不同材质的白丝会呈现出截然不同的视觉效果和穿着体验：<strong>棉质白丝</strong>柔软透气，呈现自然的哑光质感，适合日常休闲风格的洛丽塔造型；<strong>尼龙丝袜</strong>具有细腻的光泽感，能让腿部线条更加流畅优美，适合正式场合的洛丽塔造型；<strong>天鹅绒白丝</strong>质地厚实，表面有细微的绒毛光泽，触感柔软温暖，是秋冬季节洛丽塔造型的绝佳选择。</p>
<h2>白丝的图案与装饰</h2>
<p>除了纯白素色款，带有图案或装饰的白丝能为造型增添更多层次感和趣味性。<strong>蕾丝花边白丝</strong>在袜口处装饰精致的蕾丝边，甜美可爱；<strong>提花白丝</strong>则在丝袜上织出精美的图案纹样，如蔷薇花藤、蝴蝶结等；<strong>条纹或菱格白丝</strong>则更偏向学院风格，适合打造青春活力的洛丽塔造型。</p>
<h2>不同风格的白丝搭配法则</h2>
<p><strong>甜美洛丽塔</strong>适合搭配带有蕾丝花边或蝴蝶结装饰的白丝，强化甜美感；<strong>古典洛丽塔</strong>适合素色哑光白丝，展现优雅气质；<strong>哥特洛丽塔</strong>则可以大胆尝试带有暗黑图案的白丝，如蔷薇暗纹或十字架提花。</p>`,
    category: 'chuanda-zhinan',
    author: '夜樱',
    publishDate: '2026-07-08',
    readTime: '7分钟',
    imageQuery: 'White%20lace%20stockings%20and%20Lolita%20fashion%20coordination%2C%20various%20styles%20of%20white%20hosiery%20displayed%20elegantly%2C%20beautiful%20leg%20aesthetics%2C%20soft%20cream%20vanity%20background%2C%20fashion%20accessory%20editorial%20photography%20with%20gentle%20natural%20light',
    tags: ['白丝搭配', '腿部美学', '配饰指南', '材质选择'],
    featured: true,
  },
  {
    id: '8',
    slug: 'xinren-bilei-luolita-danpin',
    title: '新人必看！洛丽塔入门必备单品全攻略',
    excerpt: '刚接触洛丽塔时尚不知从何下手？本文为你整理了洛丽塔新人的必备单品清单，从裙子到袜子、从鞋履到头饰，一步步带你构建完整的洛丽塔衣橱。',
    content: `<p>刚接触洛丽塔时尚的新人往往会感到迷茫：面对琳琅满目的裙装、衬衫、裙撑、袜子、头饰……到底应该从何入手？别担心，这篇新人攻略将手把手教你构建属于自己的第一个洛丽塔衣橱。</p>
<h2>第一优先级：一条百搭的JSK</h2>
<p>跳线裙（JSK）是洛丽塔造型的核心单品，也是你最值得投资的第一件洛丽塔服装。对于新人而言，建议选择一条<strong>纯色或经典印花的基础款JSK</strong>，颜色以粉色、白色、浅蓝或黑色为宜，这些颜色最为百搭，能与多种衬衫和内搭组合。</p>
<h2>第二优先级：白丝与鞋履</h2>
<p><strong>白色及膝袜或白色连裤袜</strong>是洛丽塔造型中不可或缺的腿部搭配。对于新人来说，建议先从一条纯白素色棉质及膝袜开始，它几乎可以搭配所有风格的洛丽塔裙装。</p>
<p>鞋履方面，<strong>圆头玛丽珍鞋</strong>是洛丽塔造型的经典之选。白色、粉色或黑色的圆头玛丽珍鞋最为实用，建议选择3-5厘米的低跟款，兼顾美观与穿着舒适度。</p>
<h2>第三优先级：衬衫与裙撑</h2>
<p>如果你选择了JSK，那么一件合适的<strong>内搭衬衫</strong>必不可少。白色蕾丝衬衫是最百搭的基础款，蕾丝领口和泡泡袖的设计能为造型增添甜美感。裙撑则是塑造完美裙形的关键，一条A字型棉质裙撑就能满足大部分日常造型的需求。</p>`,
    category: 'chuanda-zhinan',
    author: '小雪',
    publishDate: '2026-07-05',
    readTime: '6分钟',
    imageQuery: 'Lolita%20fashion%20beginner%20essential%20items%20checklist%20with%20dress%20petticoat%20blouse%20white%20stockings%20and%20shoes%20laid%20out%20on%20bed%2C%20wardrobe%20planning%20concept%2C%20soft%20pink%20and%20cream%20background%2C%20organized%20fashion%20photography',
    tags: ['入门指南', '必备单品', '新人攻略', '购物清单'],
    featured: false,
  },
  {
    id: '9',
    slug: 'guochan-luolita-pinpai-tuijian',
    title: '国货之光：值得关注的十大国产洛丽塔品牌',
    excerpt: '近年来国产洛丽塔品牌异军突起，凭借精湛的工艺、亲民的价格和独特的设计理念赢得了大量粉丝。本文精选十个最值得关注的国牌洛丽塔，总有适合你的那一款。',
    content: `<p>中国洛丽塔市场的蓬勃发展孕育了一大批优秀的本土品牌。这些国牌洛丽塔不仅在设计上更加贴近亚洲女性的身材特点和审美偏好，在价格上也比日系品牌更具亲和力。以下是十个值得关注的国产洛丽塔品牌。</p>
<h2>经典国牌推荐</h2>
<p><strong>古典玩偶</strong>以其精湛的手工刺绣和高品质面料在洛丽塔圈内享有盛誉，设计风格偏向古典洛丽塔，每一件作品都堪称艺术品。<strong>仲夏物语</strong>则以清新的设计风格和舒适的穿着体验著称，擅长将洛丽塔元素融入日常穿搭。</p>
<p><strong>婴梵塔</strong>专注于甜美洛丽塔风格，以粉嫩色调和可爱的印花设计深受年轻洛丽塔爱好者的喜爱。<strong>钻石甜心</strong>则在设计上更加大胆创新，常常推出令人眼前一亮的联名系列。</p>
<p><strong>古典玩偶</strong>、<strong>豹了个猫</strong>和<strong>小熊星座</strong>也是近年来口碑极佳的国牌代表，各有其独特的设计语言和品牌调性。</p>
<h2>国牌洛丽塔的选购建议</h2>
<p>选购国牌洛丽塔时，建议先确定自己喜欢的风格流派，再针对性地关注该风格领域的代表性品牌。此外，国牌洛丽塔通常会采用<strong>预约制</strong>销售模式，需要关注品牌的官方社交账号以获取最新预约信息。试穿方面，如果条件允许，建议前往线下实体店或参加品牌举办的试穿会，亲自感受裙子的面料质感和上身效果。</p>`,
    category: 'pinpai-tuijian',
    author: '花音',
    publishDate: '2026-07-01',
    readTime: '10分钟',
    imageQuery: 'Chinese%20Lolita%20brand%20showcase%20with%20beautiful%20dresses%20displayed%20on%20mannequins%20in%20boutique%2C%20various%20styles%20from%20sweet%20to%20classic%2C%20modern%20Chinese%20fashion%20retail%20interior%2C%20elegant%20warm%20lighting%2C%20professional%20product%20photography',
    tags: ['国牌推荐', '品牌盘点', '洛丽塔品牌', '国产之光'],
    featured: false,
  },
  {
    id: '10',
    slug: 'dongji-luolita-baonuan-dapei',
    title: '冬季洛丽塔保暖穿搭：美丽不冻人的秘诀',
    excerpt: '冬天也能穿洛丽塔！掌握冬季洛丽塔的叠穿技巧和保暖秘诀，让你在寒冷的季节依然能保持甜美优雅的洛丽塔风格，美丽与温暖可以兼得。',
    content: `<p>很多洛丽塔爱好者一到冬天就把心爱的裙子收进衣柜深处，担心在寒冷的天气里穿洛丽塔会不够保暖。其实只要掌握正确的叠穿技巧和单品选择，冬天同样可以穿出美丽动人的洛丽塔造型。</p>
<h2>冬季洛丽塔的叠穿法则</h2>
<p>冬季洛丽塔穿搭的核心在于<strong>叠穿</strong>。在衬衫内可以叠加一件贴身保暖内衣（选择领口较低的款式以免外露），在JSK外可以搭配一件短款针织开衫或斗篷外套。选择<strong>长袖OP连衣裙</strong>也是冬季洛丽塔的实用之选，少了叠穿的层次却同样保暖。</p>
<h2>冬季白丝与保暖袜的选择</h2>
<p>冬季穿洛丽塔，腿部保暖尤为重要。<strong>天鹅绒白丝</strong>是冬季洛丽塔造型的最佳选择，它比普通棉质白丝更加厚实保暖，同时表面柔和的绒面光泽能为造型增添高级质感。此外，带有绒毛内里的保暖白丝也是不错的选择，外观与普通白丝无异，内里却有加绒保暖层。</p>
<h2>冬季外套与配饰</h2>
<p>一件与洛丽塔风格相配的冬季外套至关重要。短款羊毛斗篷、A字型毛呢大衣或带有蕾丝装饰的短款羽绒服都是不错的选择。配饰方面，毛绒围巾、皮革手套和毛呢贝雷帽既能保暖又能为造型增添冬日氛围感。</p>`,
    category: 'chuanda-zhinan',
    author: '素月',
    publishDate: '2026-06-28',
    readTime: '7分钟',
    imageQuery: 'Winter%20Lolita%20fashion%20with%20warm%20layered%20outfit%2C%20velvet%20dress%20and%20cape%20coat%2C%20white%20velvet%20stockings%2C%20snowy%20outdoor%20scene%20with%20soft%20winter%20light%2C%20cozy%20yet%20elegant%20editorial%20photography',
    tags: ['冬季穿搭', '保暖技巧', '叠穿法则', '天鹅绒白丝'],
    featured: false,
  },
  {
    id: '11',
    slug: 'luolita-shiliang-yunong-zhi-nan',
    title: '洛丽塔食量御纳指南：快乐享受美食的秘诀',
    excerpt: '穿着洛丽塔裙装如何优雅地享受美食？本文将分享洛丽塔爱好者专属的饮食穿搭技巧，让你在茶会和聚餐中既保持优雅又不失美食乐趣。',
    content: `<p>穿着精致的洛丽塔裙装参加茶会或聚餐时，如何在享受美食的同时保持优雅的姿态，是每位洛丽塔爱好者都会面临的小挑战。别担心，掌握了这些小技巧，你完全可以优雅地享受每一口美食。</p>
<h2>进食姿态与技巧</h2>
<p>穿着蓬松的洛丽塔裙装用餐时，<strong>坐姿</strong>是第一要务。就座前先用手轻轻抚平裙摆后方，然后从椅子前方自然坐下，让裙摆自然垂落。用餐时保持挺直的坐姿，小口进食，慢慢咀嚼——这不仅是为了保护裙装不被食物弄脏，本身就是洛丽塔优雅气质的体现。</p>
<h2>茶会用餐礼仪</h2>
<p>在正式的洛丽塔茶会上，通常会提供三层点心架。用餐顺序是<strong>从下往上、从咸到甜</strong>。拿取点心时使用点心夹或手指（根据点心类型而定），切忌用叉子去叉取精致的糕点。喝红茶时，轻轻拿起杯碟，小口啜饮，不要发出声响。</p>`,
    category: 'huodong-zixun',
    author: '小雪',
    publishDate: '2026-06-22',
    readTime: '5分钟',
    imageQuery: 'Elegant%20Lolita%20fashion%20dining%20etiquette%20at%20afternoon%20tea%2C%20beautifully%20arranged%20three-tier%20dessert%20stand%2C%20vintage%20teacups%2C%20warm%20tea%20room%20atmosphere%2C%20sophisticated%20social%20dining%20photography',
    tags: ['用餐礼仪', '茶会指南', '洛丽塔生活', '优雅技巧'],
    featured: false,
  },
  {
    id: '12',
    slug: 'luolita-huazhuang-jifa',
    title: '洛丽塔妆容技法：打造精致甜美的瓷娃娃妆容',
    excerpt: '完美的洛丽塔造型离不开精致的妆容。从底妆到底色、从眼妆到唇妆，本文将详细讲解如何打造与洛丽塔裙装相得益彰的甜美精致妆容。',
    content: `<p>一套完整的洛丽塔造型，妆容是不可或缺的组成部分。洛丽塔妆容追求的是<strong>精致、甜美、如同洋娃娃般</strong>的视觉效果，重点在于打造无瑕的底妆、自然的眼妆和甜美的唇妆。</p>
<h2>底妆：打造瓷娃娃般无瑕肌肤</h2>
<p>洛丽塔妆容的底妆追求的是<strong>陶瓷般细腻无瑕</strong>的妆效。妆前做好充分的保湿工作，选择遮盖力适中但妆感自然的粉底液或气垫，用湿润的美妆蛋轻轻拍打上妆，打造出轻薄服帖的底妆效果。局部瑕疵用遮瑕膏进行点涂遮盖，最后用透明散粉定妆，确保妆容持久不脱。</p>
<h2>眼妆：自然放大双眼的甜美系眼妆</h2>
<p>洛丽塔的眼妆以<strong>粉色系或大地色系</strong>为主，追求自然放大双眼的效果。先用浅粉色或米色眼影大面积打底，再用稍深一些的玫瑰粉色在眼尾处叠加晕染，营造出自然的层次感。眼线沿着睫毛根部细细描绘，眼尾微微下垂营造无辜感。睫毛要刷得浓密卷翘，必要时可以使用自然款假睫毛。</p>
<h2>腮红与唇妆</h2>
<p>腮红是洛丽塔妆容的灵魂所在。选择<strong>粉色系腮红</strong>，以打圈的方式大面积晕染在苹果肌位置，营造出好气色的甜美效果。唇妆方面，水润的粉色系唇釉或唇蜜是最佳选择，打造出如果冻般晶莹剔透的甜美唇妆。</p>`,
    category: 'chuanda-zhinan',
    author: '夜樱',
    publishDate: '2026-06-18',
    readTime: '7分钟',
    imageQuery: 'Lolita%20style%20makeup%20look%20with%20porcelain%20skin%20and%20pink%20tones%2C%20beautiful%20eye%20makeup%20close-up%2C%20soft%20vanity%20table%20with%20cosmetics%2C%20delicate%20feminine%20beauty%20editorial%20photography%20with%20gentle%20natural%20light',
    tags: ['妆容教程', '甜美妆容', '化妆技巧', '瓷娃娃妆'],
    featured: false,
  },
];